import styled from 'styled-components'
import React, { memo } from 'react'
import { Noto_body3_r12 } from 'src/styles/font/NotoSansKrFonts'
import { decodeBase64Html } from 'src/service/utils/decode'

interface FooterProps {
  content: string
  layoutsFooter: {
    backgroundColor: string
  }
}

const DefaultFooter = ({ content, layoutsFooter }: FooterProps) => {
  const isEmptyContent = content === '{}' || !content

  return (
    <FooterWrap $bgColor={layoutsFooter?.backgroundColor}>
      {!isEmptyContent && (
        <div
          dangerouslySetInnerHTML={{
            __html: decodeBase64Html(content),
          }}
        />
      )}
    </FooterWrap>
  )
}
export default memo(DefaultFooter)

const FooterWrap = styled.div<{ $bgColor?: string }>`
  margin-top: 20px;
  padding: 10px;
  ${Noto_body3_r12};
  background-color: ${({ $bgColor }) => $bgColor};
  ul {
    padding-left: 20px;
  }
  ol,
  li,
  ul {
    list-style: disc;
  }
  p,
  a {
    margin-bottom: 10px;
    line-height: 1.4;
  }

  strong {
    font-weight: 700;
  }
`
